export default __webpack_public_path__ + "static/media/logoW.f7b74bb8.png";